var React = require('react');

function Fill (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M386.39 288L235.78 438.61a32 32 0 0 1-45.22 0L73.37 321.4A31.86 31.86 0 0 1 64 298.78 32.59 32.59 0 0 1 65.87 288z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M502.63 217L294.94 9.34a32 32 0 0 0-45.25 0l-81.58 81.58L81.93 4.73a16 16 0 0 0-22.62 0L36.69 27.35a16 16 0 0 0 0 22.62l86.19 86.18-94.76 94.76a96 96 0 0 0 0 135.75l117.19 117.19a96 96 0 0 0 135.74 0l221.57-221.57a32 32 0 0 0 .01-45.28zM235.78 438.61a32 32 0 0 1-45.22 0L73.37 321.4a32 32 0 0 1 0-45.24l94.75-94.74 58.6 58.58A32 32 0 0 0 272 194.77l-58.6-58.6 58.92-58.93 162.42 162.41z","className":"fa-primary","key":2})]);
}

Fill.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Fill;

Fill.default = Fill;
